import React, { useState } from 'react';
import Button from '../../components/elements/button';
import FormInput from '../../components/elements/form_input';
import { Upload, Edit, Save, Map } from '../../assets/icons';
import '../../assets/css/doctor/profile.css';

const DoctorProfile = () => {
    const [editing, setEditing] = useState(false);
    const [profile, setProfile] = useState({
        personalInfo: {
            firstName: 'Sarah',
            lastName: 'Johnson',
            email: 'sarah.johnson@example.com',
            phone: '+234 800 1234 567',
            profileImage: '/doctors/sarah.jpg',
            bio: 'Fish Health Specialist with 10+ years of experience in aquaculture disease management.'
        },
        professionalInfo: {
            licenseNumber: 'VET-2024-001',
            specialization: 'Fish Health Management',
            qualifications: [
                'DVM - University of Lagos',
                'MSc Aquaculture Health - University of Stirling'
            ],
            certifications: [
                'Advanced Fish Disease Management',
                'Aquaculture Biosecurity Specialist'
            ],
            experience: '10',
            languages: ['English', 'Yoruba']
        },
        practiceInfo: {
            clinicName: 'AquaVet Clinic',
            address: 'Plot 123, Marine Road, Lagos',
            workingHours: {
                from: '09:00',
                to: '17:00'
            },
            consultationFee: '25000',
            servicesOffered: [
                'Disease Diagnosis',
                'Water Quality Assessment',
                'Health Certification',
                'Farm Inspection'
            ]
        },
        statistics: {
            totalCases: 156,
            resolvedCases: 142,
            averageRating: 4.8,
            responseRate: '98%'
        }
    });

    const handleSave = () => {
        setEditing(false);
        // Save profile changes
    };

    const handleImageUpload = (e) => {
        // Handle profile image upload
    };

    return (
        <div className="doctor-profile">
            <div className="profile-header">
                <div className="profile-overview">
                    <div className="profile-image-container">
                        <img 
                            src={profile.personalInfo.profileImage} 
                            alt="Doctor Profile" 
                            className="profile-image"
                        />
                        {editing && (
                            <button className="upload-button" onClick={() => document.getElementById('imageUpload').click()}>
                                <img src={Upload} alt="" />
                                <input 
                                    type="file" 
                                    id="imageUpload" 
                                    hidden 
                                    accept="image/*"
                                    onChange={handleImageUpload}
                                />
                            </button>
                        )}
                    </div>
                    <div className="profile-info">
                        <h1>{`Dr. ${profile.personalInfo.firstName} ${profile.personalInfo.lastName}`}</h1>
                        <p className="specialization">{profile.professionalInfo.specialization}</p>
                        <p className="license">License: {profile.professionalInfo.licenseNumber}</p>
                    </div>
                </div>
                <Button
                    icon={editing ? <img src={Save} alt="" /> : <img src={Edit} alt="" />}
                    text={editing ? 'Save Changes' : 'Edit Profile'}
                    variant={editing ? 'primary' : 'outline'}
                    onClick={editing ? handleSave : () => setEditing(true)}
                />
            </div>

            <div className="profile-content">
                <div className="main-content">
                    <section className="bio-section">
                        <h2>About Me</h2>
                        {editing ? (
                            <textarea
                                value={profile.personalInfo.bio}
                                onChange={(e) => setProfile({
                                    ...profile,
                                    personalInfo: {
                                        ...profile.personalInfo,
                                        bio: e.target.value
                                    }
                                })}
                            />
                        ) : (
                            <p>{profile.personalInfo.bio}</p>
                        )}
                    </section>

                    <section className="qualifications-section">
                        <h2>Qualifications & Certifications</h2>
                        <div className="qualifications-list">
                            {profile.professionalInfo.qualifications.map((qual, index) => (
                                <div key={index} className="qualification-item">
                                    {editing ? (
                                        <FormInput
                                            value={qual}
                                            onChange={(e) => {
                                                const newQuals = [...profile.professionalInfo.qualifications];
                                                newQuals[index] = e.target.value;
                                                setProfile({
                                                    ...profile,
                                                    professionalInfo: {
                                                        ...profile.professionalInfo,
                                                        qualifications: newQuals
                                                    }
                                                });
                                            }}
                                        />
                                    ) : (
                                        <span>{qual}</span>
                                    )}
                                </div>
                            ))}
                        </div>
                    </section>

                    <section className="services-section">
                        <h2>Services Offered</h2>
                        <div className="services-grid">
                            {profile.practiceInfo.servicesOffered.map((service, index) => (
                                <div key={index} className="service-item">
                                    {editing ? (
                                        <FormInput
                                            value={service}
                                            onChange={(e) => {
                                                const newServices = [...profile.practiceInfo.servicesOffered];
                                                newServices[index] = e.target.value;
                                                setProfile({
                                                    ...profile,
                                                    practiceInfo: {
                                                        ...profile.practiceInfo,
                                                        servicesOffered: newServices
                                                    }
                                                });
                                            }}
                                        />
                                    ) : (
                                        <span>{service}</span>
                                    )}
                                </div>
                            ))}
                        </div>
                    </section>
                </div>

                <aside className="profile-sidebar">
                    <section className="contact-info">
                        <h2>Contact Information</h2>
                        <div className="info-grid">
                            <FormInput
                                label="Email"
                                value={profile.personalInfo.email}
                                onChange={(e) => setProfile({
                                    ...profile,
                                    personalInfo: {
                                        ...profile.personalInfo,
                                        email: e.target.value
                                    }
                                })}
                                disabled={!editing}
                            />
                            <FormInput
                                label="Phone"
                                value={profile.personalInfo.phone}
                                onChange={(e) => setProfile({
                                    ...profile,
                                    personalInfo: {
                                        ...profile.personalInfo,
                                        phone: e.target.value
                                    }
                                })}
                                disabled={!editing}
                            />
                        </div>
                    </section>

                    <section className="practice-info">
                        <h2>Practice Information</h2>
                        <FormInput
                            label="Clinic Name"
                            value={profile.practiceInfo.clinicName}
                            onChange={(e) => setProfile({
                                ...profile,
                                practiceInfo: {
                                    ...profile.practiceInfo,
                                    clinicName: e.target.value
                                }
                            })}
                            disabled={!editing}
                        />
                        <div className="address-field">
                            <img src={Map} alt="" />
                            <FormInput
                                label="Address"
                                value={profile.practiceInfo.address}
                                onChange={(e) => setProfile({
                                    ...profile,
                                    practiceInfo: {
                                        ...profile.practiceInfo,
                                        address: e.target.value
                                    }
                                })}
                                disabled={!editing}
                            />
                        </div>
                    </section>

                    <section className="statistics">
                        <h2>Performance Statistics</h2>
                        <div className="stats-grid">
                            <div className="stat-item">
                                <label>Total Cases</label>
                                <span>{profile.statistics.totalCases}</span>
                            </div>
                            <div className="stat-item">
                                <label>Resolved Cases</label>
                                <span>{profile.statistics.resolvedCases}</span>
                            </div>
                            <div className="stat-item">
                                <label>Average Rating</label>
                                <span>{profile.statistics.averageRating}/5</span>
                            </div>
                            <div className="stat-item">
                                <label>Response Rate</label>
                                <span>{profile.statistics.responseRate}</span>
                            </div>
                        </div>
                    </section>
                </aside>
            </div>
        </div>
    );
};

export default DoctorProfile;